'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var plugin = require('tailwindcss/plugin');
var colors_bg = require('../extend/colors.bg.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var plugin__default = /*#__PURE__*/_interopDefaultCompat(plugin);

var borderGradient = plugin__default.default(({ addUtilities, e, theme })=>{
    const borderGradient = theme('borderGradient', {});
    const components = Object.entries(borderGradient).map(([key, value])=>({
            [key === 'DEFAULT' ? `.${e('border-gradient')}` : `.${e(`border-gradient-${key}`)}`]: {
                // Our custom "selected" borderGradient classes need to specify BG color,
                // so can't have the linear-gradient(white, white) baked in by default.
                backgroundImage: key.includes('selected') ? value : `linear-gradient(${colors_bg.backgroundColor.surface.primary}, ${colors_bg.backgroundColor.surface.primary}), ${value}`,
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box',
                borderColor: 'transparent'
            }
        }));
    addUtilities(components);
});

exports.default = borderGradient;
//# sourceMappingURL=borderGradient.js.map
